var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"tw-relative tw-border-l tw-border-l-solid tw-border-grey-200 tw-list-none tw-space-y-10"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }